import {Links} from '../services/generated';
import {ProcessSubscriptionDto} from '../services/generated/models/ProcessSubscriptionDto';

export class ProcessSubscription implements ProcessSubscriptionDto {
  id: number;
  processTitle: string | null;
  processOwnerAzureId: string;
  subscribersAzureIds: string[];
  branchSubscribersAzureIds: string[];
  link: Links[] | null;
  modified: boolean = false;
  isBranchSubscribed: boolean = false;

  constructor(processSubscriptionDto: ProcessSubscriptionDto) {
    this.id = processSubscriptionDto.id;
    this.processTitle = processSubscriptionDto.processTitle;
    this.processOwnerAzureId = processSubscriptionDto.processOwnerAzureId;
    this.subscribersAzureIds = processSubscriptionDto.subscribersAzureIds;
    this.branchSubscribersAzureIds = processSubscriptionDto.branchSubscribersAzureIds;
    this.link = processSubscriptionDto.link;
  }
}